import { IconButton, Tooltip } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export interface ExpandToggleCellProps {
  isExpanded: boolean;
  onToggle: () => void;
  ariaLabel?: string;
}

/**
 * Reusable expandable row toggle cell component
 *
 * Usage in table config:
 * ```tsx
 * [COLUMN_IDS.EXPAND]: ({ _customRowProps, id }) => {
 *   const isExpanded = _customRowProps.expandedIds?.has(id);
 *   return (
 *     <ExpandToggleCell
 *       isExpanded={isExpanded}
 *       onToggle={() => _customRowProps.onToggleExpand(id)}
 *     />
 *   );
 * }
 * ```
 */
const ExpandToggleCell = ({
  isExpanded,
  onToggle,
  ariaLabel = 'Expand row',
}: ExpandToggleCellProps) => {
  const handleClick: React.MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation();
    onToggle();
  };

  return (
    <Tooltip title={isExpanded ? 'Collapse' : 'Expand'}>
      <span>
        <IconButton size="small" onClick={handleClick} aria-label={ariaLabel}>
          {isExpanded ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
      </span>
    </Tooltip>
  );
};

export default ExpandToggleCell;
